module.exports = __webpack_public_path__ + "img/loader.692c842c.png";